import SignUpContainer from "./SignUpContainer";

/**
 * 회원가입 화면
 */
export default SignUpContainer;